import { render, staticRenderFns } from "./MergeMatched.vue?vue&type=template&id=427e9736"
import script from "./MergeMatched.vue?vue&type=script&lang=js"
export * from "./MergeMatched.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports